if (document.body.classList.contains('page-template-page-promotion-year') || document.body.classList.contains('page-template-page-laureat')) {
  // @ts-ignore
  const swiper = new Swiper(".mySwiper", {
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
  });

  // @ts-ignore
  const partnersSwiper: Swiper = new Swiper("#partners-swiper", {
    spaceBetween: 10,
    centerInsuficientSlides: true,
     autoplay: {
       delay: 6000,
       disableOnInteraction: false,
     },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      '0': {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      '768': {
        slidesPerView: 3,        
        spaceBetween: 20,      
      }
    }
  });

  const divisiveYearLines = document.getElementsByClassName('blue-divisive-line');
  let windowSize = window.screen.width;
  if (windowSize < 768) {
    divisiveYearLines[1].classList.add('display-none');
  }

  window.addEventListener('resize', () => {
    windowSize = window.screen.width;
    if (windowSize < 768) {
      divisiveYearLines[1].classList.add('display-none');
    } else {
      divisiveYearLines[1].classList.remove('display-none');
    }
  })

  const promotionYearSelected = window.location.href.split('/')[4].split('-')[1]; //gets year from url

  const yearLinks = [].slice.call(document.getElementsByClassName('year-link'));
  yearLinks.forEach(link => {
    if (link.innerHTML === promotionYearSelected) link.classList.add('selected-year');
  });

  if (document.body.classList.contains('page-template-page-promotion-year')) {
    // @ts-ignore
    const popups = $('.youtube, .popup-vimeo, .popup-gmaps');
    // @ts-ignore
    popups.magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }
}
